//@ts-nocheck
import Header from 'dot/Components/Header'
import React from 'react'

const Redirect = () => {
  return (
    <>
    <p> Redirecting...... !!!</p>
    </>
  )
}

export default Redirect